/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Gmail_SearchInputs */

const es_tools_gmail_search = /** @type {(inputs: Tools_Gmail_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando en Gmail...`)
};

const en_tools_gmail_search = /** @type {(inputs: Tools_Gmail_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching Gmail...`)
};

/**
* | output |
* | --- |
* | "Searching Gmail..." |
*
* @param {Tools_Gmail_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_gmail_search = /** @type {((inputs?: Tools_Gmail_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Gmail_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_gmail_search(inputs)
	return en_tools_gmail_search(inputs)
});
export { tools_gmail_search as "tools.gmail.search" }